import { render } from "./CreateRoundType.vue?vue&type=template&id=6256e289&scoped=true"
import script from "./CreateRoundType.vue?vue&type=script&lang=js"
export * from "./CreateRoundType.vue?vue&type=script&lang=js"

import "./CreateRoundType.vue?vue&type=style&index=0&id=6256e289&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6256e289"]])

export default __exports__